import { render, staticRenderFns } from "./CustomIndex.vue?vue&type=template&id=ad777a84&scoped=true&"
import script from "./CustomIndex.vue?vue&type=script&lang=js&"
export * from "./CustomIndex.vue?vue&type=script&lang=js&"
import style0 from "./CustomIndex.vue?vue&type=style&index=0&id=ad777a84&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad777a84",
  null
  
)

export default component.exports